const calcCurrentConcern = (data) => {

    if (data.criteriaLow === '' || data.criteriaHigh === '' || data.currentValue === '') {
        data.currentConcern = -1
    } else {
        let minCriteria = parseFloat(Math.min(data.criteriaLow, data.criteriaHigh));

        let maxCriteria = parseFloat(Math.max(data.criteriaLow, data.criteriaHigh));

        if (data.currentValue < minCriteria || data.currentValue > maxCriteria) {
            data.currentConcern = 1;
        } else {
            data.currentConcern = 0;
        }
    }

    return data.currentConcern
}

export default calcCurrentConcern